module.exports = __webpack_public_path__ + "img/75685.00a15db2.svg";